export const CashBuildElementIdEnum = {
    ROOT_CASHBUILD: 'root-cashbuild',
    EMAIL: 'email',
    STORE_ID: 'id-store',
} as const;

export type CashBuildElementIdType =
    (typeof CashBuildElementIdEnum)[keyof typeof CashBuildElementIdEnum];
